import React from 'react';
import { Modal } from 'reactstrap';
import { TypedMemo } from '../../common/types';
import { EmbedSmartLinkModalProps } from './props';
import { EmbedSheet } from './EmbedSheet';
import styles from './EmbedSmartLinkModal.module.scss';

/**
 * The embed sheet's shell, on web and Electron.
 *
 * The body is mounted only while the sheet is open: it loads the page in a
 * frame and reads the account, and neither is worth doing for a sheet nobody
 * has opened.
 *
 * React Native keeps the old modal — the sheet leans on a scaled preview and a
 * code block, neither of which the mobile app can show.
 */
const EmbedSmartLinkModalComponent: React.FC<EmbedSmartLinkModalProps> = ({
  isOpen,
  closeModal,
  embedUrl,
  accountId,
  pageName,
}) => (
  <Modal isOpen={isOpen} toggle={closeModal} centered className={styles.dialog} contentClassName={styles.sheet}>
    {isOpen && <EmbedSheet embedUrl={embedUrl} accountId={accountId} pageName={pageName} closeModal={closeModal} />}
  </Modal>
);

export const EmbedSmartLinkModal = TypedMemo(EmbedSmartLinkModalComponent);
